module.exports = __webpack_public_path__ + "static/img/6400_phase_function_Paper_Points.ff4cbae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6400_phase_function_Paper_Points.png
// module id = ii20
// module chunks = 0